import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type SkillRubricConfigFragment = { label: string, value: number };


export type SkillRubricConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SkillRubricConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment SkillRubricConfig on SkillRubricConfigType {
  label
  value
}
    `;